import { render, staticRenderFns } from "./AddNoContact.vue?vue&type=template&id=b6bcd5b8&scoped=true&"
import script from "./AddNoContact.vue?vue&type=script&lang=js&"
export * from "./AddNoContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bcd5b8",
  null
  
)

export default component.exports